import { render, staticRenderFns } from "./DoseDistribuitionRegionCampaignEditForm.vue?vue&type=template&id=297b5841&"
import script from "./DoseDistribuitionRegionCampaignEditForm.vue?vue&type=script&lang=js&"
export * from "./DoseDistribuitionRegionCampaignEditForm.vue?vue&type=script&lang=js&"
import style0 from "./DoseDistribuitionRegionCampaignEditForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports